import { WizardSideNav } from "../../../../common/wizard/WizardSideNav";
import { REQUEST_WIZARD_STEPS, useRequestStepLabel, type RequestStep } from "./requestWizardSteps";

interface Props {
  currentStep: RequestStep;
  navigateToStep: (step: RequestStep) => void;
}

export const RequestWizardNav = ({ currentStep, navigateToStep }: Props) => (
  <WizardSideNav
    steps={REQUEST_WIZARD_STEPS}
    currentStep={currentStep}
    navigateToStep={navigateToStep}
    stepLabel={useRequestStepLabel()}
  />
);
